<template>
  <div>
    <v-container>
      <div
        v-if="overlay == true"
        id="cargando"
        wire:loading
        class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center"
      >
        <div
          class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"
        ></div>
        <h2 class="text-center text-white text-xl font-semibold">
          Cargando...
        </h2>
        <p class="w-1/3 text-center text-white">
          Esto puede tardar unos segundos, no cierre esta página.
        </p>
      </div>
      <!--<div v-if="!valida">
                <tramites :nrreporte="reporte" :svindice="indice" :aiclave="aiclave" :ceclave="ceclave" @cambioTramite="cambioTramite"></tramites>
            </div>-->
      <div>
        <v-card>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              <v-card
                flat
                class="text-xs-center ma-8"
                width="100%"
                id="actions-container"
              >
                <v-card-title class="justify-center primary">
                  <v-toolbar-title id="titulocard">Seguimiento</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-icon>mdi-badge-account-alert</v-icon>
                </v-card-title>
                <v-divider></v-divider>

                <v-card-text>
                  <v-row>
                    <v-col lg="6" sm="6" md="6" cols="12" class="pb-0">
                      <vs-list>
                        <v-row justify="end">
                          <v-spacer></v-spacer>
                          <v-col md="auto">
                            <span>NO</span>
                          </v-col>
                          <v-col md="auto" class="mr-5">
                            <span>SI</span>
                          </v-col>
                        </v-row>
                      </vs-list>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            Primer contacto satisfactorio
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <vs-list>
                            <v-row justify="center" align-content="center">
                              <v-col class="px-5">
                                <input
                                  v-model="mvts.s818"
                                  type="range"
                                  name="points"
                                  @click="setMovimiento(mvts.s818, 818)"
                                  min="1"
                                  step="1"
                                  id="s818"
                                  class="custom-toggle bg-dis tgl-dis disable-action"
                                  max="3"
                                />
                              </v-col>
                            </v-row>
                          </vs-list>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider></v-divider>

                      <v-list-item>
                          <v-list-item-content>
                              <v-list-item-title>
                                  Envío de check list al asegurado
                              </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                              <vs-list>
                                  <v-row justify="center" align-content="center">
                                      <v-col class="px-6">
                                          <v-switch color="success"
                                                    id="s817"
                                                    v-model="mvts.s817"
                                                    @change="setMovimiento(1, 817)">
                                          </v-switch>
                                      </v-col>
                                  </v-row>
                              </vs-list>
                          </v-list-item-action>
                      </v-list-item>

                      <v-divider></v-divider>
                        <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            Documentación digital validada
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <vs-list>
                            <v-row justify="center" align-content="center">
                              <v-col class="px-5 disable-action" id="s819">
                                <v-switch
                                  color="success"
                                  v-model="mvts.s819"
                                ></v-switch>
                              </v-col>
                            </v-row>
                          </vs-list>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider></v-divider>
                        <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            Documentación legal validada
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <vs-list>
                            <v-row justify="center" align-content="center">
                              <v-col class="px-5">
                                <input
                                  v-model="mvts.s820"
                                  type="range"
                                  name="points"
                                  @click="setMovimiento(mvts.s820, 820)"
                                  min="1"
                                  step="1"
                                  id="s820"
                                  class="
                                    custom-toggle
                                    bg-dis
                                    tgl-dis
                                    disable-action
                                  "
                                  max="3"
                                />
                              </v-col>
                            </v-row>
                          </vs-list>
                        </v-list-item-action>
                      </v-list-item>
                        <v-divider v-if="mvts.s820 == 1"></v-divider>
                      <v-list-item v-if="mvts.s820 == 1">
                        <v-list-item-content>
                          <v-list-item-title>
                            Respuesta cliente validación legal
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <vs-list>
                            <v-row justify="center" align-content="center">
                              <v-col class="px-5">
                                <input
                                  v-model="mvts.s821"
                                  type="range"
                                  name="points"
                                  @click="setMovimiento(mvts.s821, 821)"
                                  min="1"
                                  step="1"
                                  id="s821"
                                  class="
                                    custom-toggle
                                    bg-dis
                                    tgl-dis
                                    disable-action
                                  "
                                  max="3"
                                />
                              </v-col>
                            </v-row>
                          </vs-list>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider></v-divider>
                        <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            Recolección de documentos físicos
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <vs-list>
                            <v-row justify="center" align-content="center">
                              <v-col id="s822" class="px-5 disable-action">
                                <v-switch
                                  color="success"
                                  v-model="mvts.s822"
                                  @click="setMovimiento(mvts.s822, 822)"
                                ></v-switch>
                              </v-col>
                            </v-row>
                          </vs-list>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider></v-divider>
                    </v-col>
                    <v-col lg="6"
                           sm="6"
                           md="6"
                           cols="12"
                           class="notShowOnSmall">
                        <vs-list class="d-none d-sm-flex">
                            <v-row justify="end">
                                <v-spacer></v-spacer>
                                <v-col md="auto">
                                    <span>NO</span>
                                </v-col>
                                <v-col md="auto" class="mr-5">
                                    <span>SI</span>
                                </v-col>
                            </v-row>
                        </vs-list>
                        <v-divider class="d-none d-sm-flex"></v-divider>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Recepción de documentos físicos
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <vs-list>
                                    <v-row justify="center" align-content="center">
                                        <v-col class="px-5">
                                            <input v-model="mvts.s823"
                                                   @click="setMovimiento(mvts.s823, 823)"
                                                   type="range"
                                                   name="points"
                                                   min="1"
                                                   step="1"
                                                   id="s823"
                                                   class="
                                    custom-toggle
                                    bg-dis
                                    tgl-dis
                                    disable-action
                                  "
                                                   max="3" />
                                        </v-col>
                                    </v-row>
                                </vs-list>
                            </v-list-item-action>
                        </v-list-item>

                        <v-divider></v-divider>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Documentación física validada
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <vs-list>
                                    <v-row justify="center" align-content="center">
                                        <v-col class="px-5">
                                            <input v-model="mvts.s824"
                                                   @click="dothis()"
                                                   type="range"
                                                   name="points"
                                                   min="1"
                                                   step="1"
                                                   id="s824"
                                                   class="
                                    custom-toggle
                                    bg-dis
                                    tgl-dis
                                    disable-action
                                  "
                                                   max="3" />
                                        </v-col>
                                    </v-row>
                                </vs-list>
                            </v-list-item-action>
                        </v-list-item>
                        <v-divider v-if="mvts.s824 == 1"></v-divider>
                        <v-list-item v-if="mvts.s824 == 1">
                            <v-list-item-content>
                                <v-list-item-title>
                                    Respuesta cliente validación física
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <vs-list>
                                    <v-row justify="center" align-content="center">
                                        <v-col class="px-5">
                                            <input v-model="mvts.s834"
                                                   type="range"
                                                   name="points"
                                                   @click="setMovimiento(mvts.s834, 834)"
                                                   min="1"
                                                   step="1"
                                                   id="s834"
                                                   class="
                                    custom-toggle
                                    bg-dis
                                    tgl-dis
                                    disable-action
                                  "
                                                   max="3" />
                                        </v-col>
                                    </v-row>
                                </vs-list>
                            </v-list-item-action>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Liberación de expediente
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <vs-list>
                                    <v-row justify="center" align-content="center">
                                        <v-col class="px-5 disable-action" id="s825">
                                            <v-switch color="success"
                                                      v-model="mvts.s825"
                                                      @click="setMovimiento(mvts.s825, 825)"></v-switch>
                                        </v-col>
                                    </v-row>
                                </vs-list>
                            </v-list-item-action>
                        </v-list-item>

                        <v-divider></v-divider>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Envío de expediente
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <vs-list>
                                    <v-row justify="center" align-content="center">
                                        <v-col class="px-5 disable-action" id="s826">
                                            <v-switch color="success"
                                                      v-model="mvts.s826"
                                                      @click="setMovimiento(mvts.s826, 826)"></v-switch>
                                        </v-col>
                                    </v-row>
                                </vs-list>
                            </v-list-item-action>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Acuse de recibido
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <vs-list>
                                    <v-row justify="center" align-content="center">
                                        <v-col class="px-5 disable-action" id="s827">
                                            <v-switch color="success"
                                                      v-model="mvts.s827"
                                                      @click="setMovimiento(mvts.s827, 827)"></v-switch>
                                        </v-col>
                                    </v-row>
                                </vs-list>
                            </v-list-item-action>
                        </v-list-item>


                        <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>

        <template>
          <v-container>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header class="primary">
                  <v-toolbar-title id="titulocard">Tramites</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <template v-slot:actions>
                    <v-icon color="white"> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                    <v-card-text>
                        <v-row>
                            <v-col lg="5" sm="5" md="5" cols="12" offset-md="1">
                                <v-btn v-if="valconclusion == 0 && valSeguimiento == 1"
                                       class="mx-2"
                                       title="Llamada de Seguimiento"
                                       @click="irMovimiento(644)"
                                       fab
                                       dark
                                       small
                                       color="green">
                                    <v-icon dark> mdi-phone </v-icon>
                                </v-btn>
                                <v-btn v-if="valconclusion == 1 || valSeguimiento == 0"
                                       class="mx-2"
                                       title="Llamada de Seguimiento"
                                       fab
                                       dark
                                       small
                                       color="green">
                                    <v-icon dark> mdi-phone </v-icon>
                                </v-btn>
                                <span style="color: black; text-align: center">Llamada de Seguimiento</span>
                            </v-col>
                            <v-col lg="5" sm="5" md="5" cols="12" offset-md="1">
                                <v-btn v-if="valconclusion == 0 && valdocsausa == 1"
                                       class="mx-2"
                                       title="Aplicar Demérito"
                                       @click="irMovimiento(835)"
                                       fab
                                       dark
                                       small
                                       color="green">
                                    <v-icon dark> mdi-ballot-outline </v-icon>
                                </v-btn>
                                <v-btn v-if="valconclusion == 1 || valdocsausa == 0"
                                       class="mx-2"
                                       title="Aplicar Demérito"
                                       fab
                                       dark
                                       small
                                       color="green">
                                    <v-icon dark> mdi-ballot-outline </v-icon>
                                </v-btn>
                                <span style="color: black; text-align: center">Aplicar Demérito</span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
        </template>

        <MovimientosReporte></MovimientosReporte>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import MovimientosReporte from "@/components/pages/GestoriaDoc/Seguimientos.vue";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import seguimientoService from "@/services/Seguimiento/seguimiento.service.js";

export default {
  components: {
    MovimientosReporte,
  },
  data() {
    return {
      tipoAsistencia: [],
      tipo: "Envío de check list al asegurado",
      loading2: null,
      loading: null,
      date: null,
      fechasS: null,
      errorValidacion: "",
      overlay: true,

      mvts: {
        s817: 0,
        s818: 2,
        s819: 0,
        s820: 2,
        s821: 2,
        s822: 0,
        s823: 2,
        s824: 2,
        s825: 0,
        s826: 0,
        s827: 0,
        s834: 2,
      },
      pregunta1band: 0,
      pregunta2band: 0,

      lastClave: null,
      valida: true,
      reporte: 0,
      indice: 0,
      aiclave: 0,
      ceclave: 0,
      valconclusion: 1,
      valdocsausa: 0,
      valSeguimiento: 0,

      validaConclusion: false,
    };
  },
  props: ["tAsistencia", "nrreporte", "svindice"],
  computed: {
    ...mapState({ drawer: (state) => state.drawer }),
    ...mapState(["domain", "informationPage"]),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
    },
  },
  watch: {},
  async mounted() {
    // let datos = JSON.parse(sessionStorage.getItem("reporte"));
    let datos = await MetodosGenerales.obtenerSessionReporte("reporte");
    this.reporte = datos.nrreporte;
    this.indice = datos.svindice;
    this.aiclave = datos.aiclave;

    seguimientoService.validarTramites(this);

    this.obtenerEstadoMovimientos();

    this.obtenerCargaInicial();
  },
  updated() {
    this.Change3StateSwitch("s821", this.pregunta1band, true);
    this.Change3StateSwitch("s834", this.pregunta2band, true);
  },
  methods: {
    cambioTramite(valor) {
      this.valida = valor;
    },
    irMovimiento(ceclave) {
      //this.ceclave = ceclave;
      //this.valida = false;
      this.$router.push({
        name: "Tramites",
        params: {
          nrreporte: this.reporte,
          svindice: this.indice,
          aiclave: this.aiclave,
          ceclave: ceclave,
        },
      });
    },

    async obtenerCargaInicial() {
      await this.obtenerEstadoMovimientos();
      await this.obtenerEstadoReporte();

      setTimeout(() => {
        this.overlay = false;
      }, "500");
    },

    async obtenerEstadoReporte() {
      this.validaConclusion = await MetodosGenerales.getReporteEstatus(this);

      if (this.validaConclusion == false) {
        this.setDisabled("actions-container");
      }
    },

    async obtenerEstadoMovimientos() {
      //let reporte = JSON.parse(sessionStorage.getItem("reporte"));
      let reporte = await MetodosGenerales.obtenerSessionReporte("reporte");
      var respuesta = await seguimientoService.ObtenerEstadoMovimientos(
        reporte.nrreporte,
        reporte.svindice
      );

      respuesta.sort(function (a, b) {
        return a.ceclave - b.ceclave;
      });
      this.Change3StateSwitch("s818", 2, false);
      //console.log("La Respuesta: ", respuesta);

      respuesta.forEach((element) => {
        if ([818, 820, 821, 823, 824, 834].includes(element.ceclave)) {
          let valor = 2;
          let valorText = element.exresp;
          if (valorText.includes("S")) {
            valor = 3;
          }
          if (valorText.includes("N")) {
            valor = 1;
          }
          const id = "s" + element.ceclave.toString();
          this.mvts[id] = valor;
          if (element.ceclave == 818 && valor == 3) {
            this.Change3StateSwitch("s818", valor, true);
          } else if (element.ceclave == 820) {
            this.Change3StateSwitch("s820", valor, true);
          } else if (element.ceclave == 821) {
            this.Change3StateSwitch("s821", valor, true);
            this.pregunta1band = valor;
          } else if (element.ceclave == 823) {
            this.Change3StateSwitch("s823", valor, true);
          } else if (element.ceclave == 824) {
            this.Change3StateSwitch(id, valor, true);
          } else if (element.ceclave == 834) {
            this.Change3StateSwitch(id, valor, true);
            this.pregunta2band = valor;
          } else {
            this.Change3StateSwitch(id, valor, false);
          }

          // DESBLOQUEAR AQUI LOS SALTOS

           if (element.ceclave == 834 && valor == 3) {
            respuesta.some((obj) => {
              if (obj.ceclave == 825) {
                this.Change2StateSwitch("s825", 1, false);
              } 
              if (obj.ceclave == 834) {
                this.Change2StateSwitch("s825", 0, false);
              }
               return obj.ceclave === 825; 
            });
          }

           if (element.ceclave == 820 && valor == 3) {
            this.Change2StateSwitch("s822", 0, false);
          }
          if (element.ceclave == 821 && valor == 3) {
            this.Change2StateSwitch("s822", 0, false);
          } 
           if (element.ceclave == 824 && valor == 3) {
            this.Change2StateSwitch("s825", 0, false);
          } 
        }

        if ([817, 819, 822, 825, 826, 827].includes(element.ceclave)) {
          let valor = 0;
          let valorText = element.exresp;
          if (valorText.includes("S")) {
            valor = 1;
          }
          const id = "s" + element.ceclave.toString();
          this.mvts[id] = valor;

           if (element.ceclave == 822 && valor == 1) {
            this.Change2StateSwitch("s822", 1, true);
          } 
          //   if (element.ceclave == 822 && valor == 1) {
          //     this.Change3StateSwitch("s823", 2, false);
          //   }

          if (element.ceclave == 825 && valor == 1) {
            this.Change2StateSwitch("s825", 1, true);
          }
          if (element.ceclave == 825 && valor == 1) {
            this.Change2StateSwitch("s826", 0, false);
          }

          if (element.ceclave == 826 && valor == 1) {
            this.Change2StateSwitch("s826", 1, true);
          }
          if (element.ceclave == 826 && valor == 1) {
            this.Change2StateSwitch("s827", 0, false);
          }

          if (element.ceclave == 827 && valor == 1) {
            this.Change2StateSwitch("s827", 1, true);
          }
        }
      });
    },

    Change2StateSwitch(elementId, value, disabled) {
      this.mvts[elementId] = value;
      if (disabled == true) {
        document.getElementById(elementId).classList.add("disable-action");
      } else {
        document.getElementById(elementId).classList.remove("disable-action");
      }
    },

    async setMovimiento(valor, opcion) {
      if (valor == 2) {
        let id = "s" + opcion;
        this.mvts[id] = 2;
        this.$swal({
          position: "center",
          icon: "warning",
          title: "Advertencia",
          text: "Por favor seleccione SI o NO para este tipo de movimiento",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: true,
          timer: 4000,
          confirmButtonText: "Ok!",
        });
      } else {
        //let datos = JSON.parse(sessionStorage.getItem('reporte'));
        let datos = await MetodosGenerales.obtenerSessionReporte("reporte");
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("ceclave", opcion);
        this.axios
          .post(
            `${this.domain.domainNameForApi}SeguimientosReporte/ValidacionMovimientos`,
            formData
          )
          .then((response) => {
            if (response.data[0].Validacion === "") {
              this.$router.push({
                name: "ReporteSeguimientoAgregarMovimientoGD",
                params: { opc: opcion, valor: valor },
              });
            } else {
              console.log(opcion);
              if (opcion == 817) {
                this.$swal({
                  position: "center",
                  icon: "warning",
                  title: "Advertencia",
                  text: response.data[0].Validacion,
                  showDenyButton: true,
                  confirmButtonText: "SI",
                  denyButtonText: `NO`,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    this.$router.push({
                      name: "ReporteSeguimientoAgregarMovimientoGD",
                      params: { opc: opcion, valor: valor },
                    });
                  } else if (result.isDenied) {
                    this.Change2StateSwitch("s817", 0, false);
                  }
                });
              } else {
                this.$swal({
                  position: "center",
                  icon: "warning",
                  title: "Advertencia",
                  text: response.data[0].Validacion,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  showConfirmButton: true,
                  timer: 4000,
                  confirmButtonText: "Ok!",
                });
              }
            }
          });
      }
    },

    setDisabled(elementId) {
      document.getElementById(elementId).classList.add("disable-action");
    },

    Change3StateSwitch(elementId, value, des) {
      var exist = document.getElementById(elementId);
      //console.log("Entraste a ", elementId, " con el valor: ", value , "y el disabled en:",des, " Exist trae: ",exist);
      if (typeof exist != "undefined" && exist != null) {
        if (value == 1) {
          document
            .getElementById(elementId)
            .classList.remove(
              "tgl-def",
              "tgl-on",
              "bg-on",
              "bg-def",
              "bg-dis",
              "tgl-dis",
              "disable-action"
            );
          if (des == true) {
            document
              .getElementById(elementId)
              .classList.add("tgl-off", "bg-off", "disable-action");
          } else {
            document
              .getElementById(elementId)
              .classList.add("tgl-off", "bg-off");
          }
        } else if (value == 2) {
          document
            .getElementById(elementId)
            .classList.remove(
              "tgl-on",
              "tgl-off",
              "bg-on",
              "bg-off",
              "bg-dis",
              "tgl-dis",
              "disable-action"
            );
          if (des == true) {
            document
              .getElementById(elementId)
              .classList.add("tgl-def", "bg-def", "disable-action");
          } else {
            document
              .getElementById(elementId)
              .classList.add("tgl-def", "bg-def");
          }
        } else if (value == 3) {
          document
            .getElementById(elementId)
            .classList.remove(
              "tgl-off",
              "tgl-def",
              "bg-def",
              "bg-off",
              "bg-dis",
              "tgl-dis",
              "disable-action"
            );
          if (des == true) {
            document
              .getElementById(elementId)
              .classList.add("tgl-on", "bg-on", "disable-action");
          } else {
            document.getElementById(elementId).classList.add("tgl-on", "bg-on");
          }
        }
      }
    },
  },
};
</script>

<style>
.custom-toggle {
  -webkit-appearance: none;
  appearance: none;
  height: 15px;
  width: 45px;
  background-color: #2195f37e;
  -webkit-border-radius: 25px;
  border-radius: 25px;
  padding: 0px;
  margin: 0;
  cursor: pointer;
  transition: background-color 0.25s ease-in-out;
  transition: position 0.25s ease-in-out;
}

.disable-action {
  pointer-events: none;
}

.bg-dis {
  background-color: #c5c5c5;
}

.bg-def {
  background-color: #74a4d9;
}

.bg-off {
  background-color: #fb9494;
}

.bg-on {
  background-color: #89e4c5;
}

.custom-toggle.tgl-dis::-webkit-slider-thumb {
  background-color: #ffffff;
  transition: background-color 0.25s ease-in-out;
  transition: position 0.25s ease-in-out;
}

.custom-toggle.tgl-def::-webkit-slider-thumb {
  background-color: #1867c0;
  transition: background-color 0.25s ease-in-out;
  transition: position 0.25s ease-in-out;
}

.custom-toggle.tgl-on::-webkit-slider-thumb {
  background-color: #3cd4a0;
  transition: background-color 0.25s ease-in-out;
  transition: position 0.25s ease-in-out;
}

.custom-toggle.tgl-off::-webkit-slider-thumb {
  background-color: #ff5252;
  transition: background-color 0.25s ease-in-out;
  transition: position 0.25s ease-in-out;
}

.custom-toggle::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 21px;
  height: 21px;
  -webkit-border-radius: 25px;
  border-radius: 25px;
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.25);
}

.custom-toggle:focus {
  outline: none;
}

.notShowOnSmall {
  padding-top: auto;
}

@media only screen and (max-width: 599px) {
  .notShowOnSmall {
    padding-top: 0px;
  }
}
</style>
